var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "g",
    { attrs: { id: "ocean" + _vm._uid } },
    [
      _c("rocks"),
      _c(
        "g",
        { attrs: { transform: "translate(900 -75)" } },
        [_c("lighthouse")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }